/**
 * VisibilityToggle -- A toggle switch for showing/hiding items.
 *
 * Uses a styled checkbox with accessible labelling.
 */

export interface VisibilityToggleProps {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function VisibilityToggle({
  label,
  checked,
  onChange,
  disabled = false,
}: VisibilityToggleProps) {
  return (
    <label className="visibility-toggle">
      <input
        type="checkbox"
        className="visibility-toggle__input"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        disabled={disabled}
        aria-label={`Show ${label}`}
      />
      <span className="visibility-toggle__track">
        <span className="visibility-toggle__thumb" />
      </span>
      <span className="visibility-toggle__label">{label}</span>
    </label>
  );
}
